import React, { useState, useEffect } from 'react';
import { axiosInstance, convertFilterFormat } from '@appblocks/frontend/client/utils';
import { connect, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import {
    FaPen,
} from 'react-icons/fa';
import ReactJson from 'react-json-view';
import DataPaginationRenderer from '@appblocks/frontend/cloudclient/Components/DataPaginationRenderer';
import InputRenderer from './InputRenderer';
import TimeRangePicker from './TimeRangePicker';


export default function PageEvents(props) {
    const [events, setEvents] = useState([]);
    const [total, setTotal] = useState(0);
    const workspaces = useSelector(state => state.workspaces);

    const getEvents = async ({
        search, start, count, startTime, endTime, filters,
    }) => {
        const tmpFilters = [
            ...filters.map((filter) => {
                return {
                    ...filter,
                    field: `data.${filter.field}`,
                };
            }),
            {
                field: 'type',
                operator: '==',
                value: props.type || 'event',
            },
        ];
        const parsedFilters = convertFilterFormat(tmpFilters);
        const res = await axiosInstance.get(`${process.env.API_URL}/cgg/devices/${props.deviceId ? `${props.deviceId}/` : ''}logs`, {
            params: {
                searchField: props.searchField || 'data',
                search,
                start,
                count,
                startTime,
                endTime,
                workspace: workspaces.currentWorkspace,
                ...parsedFilters,
            },
        });
        setEvents(res.data.data);
        setTotal(res.data.count);
    };

    return (
        <>
            <DataPaginationRenderer
                total={total}
                timeRange
                getItems={getEvents}
                showAutoRefresh
            >
                <div className="table-responsive table-rounded shadow-sm mb-2">
                    <Table>
                        <thead className="table-secondary">
                            <tr>
                                <th>Device</th>
                                <th>Data</th>
                                <th>Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {events.length === 0 && (
                                <tr>
                                    <td colSpan={10}>
                                        <div className="table-empty-state-container">
                                            No Device Log entries found.
                                        </div>
                                    </td>
                                </tr>
                            )}
                            {events.map((event) => {
                                return (
                                    <tr key={event._id}>
                                        <td>
                                            {
                                                event.device.name ? (
                                                    <Link to={`/devices/${event.device.deviceId}`}>
                                                        {event.device.name}
                                                    </Link>
                                                ) : (
                                                    <span>{event.device.deviceId}</span>
                                                )
                                            }
                                        </td>
                                        <td>
                                            {props.type !== 'debug' ? (
                                                <ReactJson
                                                    src={event.data}
                                                    name={null}
                                                    // collapsed
                                                    displayDataTypes={false}
                                                    enableClipboard={false}
                                                />
                                            ) : (
                                                <span>
                                                    {event.data.toString()}
                                                </span>
                                            )}
                                        </td>
                                        <td>
                                            {new Date(event.createdAt).toLocaleString()}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </div>
            </DataPaginationRenderer>
        </>

    );
}
